import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { auth } from '../../firebase';
import headerStyles from './HeaderButtons.module.css';

const HeaderButtons = () => {
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            setIsLoggedIn(!!user);
        });
        return () => unsubscribe();
    }, []);

    const handleLogout = () => {
        auth.signOut();
    };

    return (
        <div className={headerStyles.buttons}>
            {isLoggedIn ? (
                <>
                    <Link to="/dashboard" className={headerStyles.greenButton}>Dashboard</Link>
                    <Link to="/" className={headerStyles.greyButton} onClick={handleLogout}>Log Out</Link>
                </>
            ) : (
                <>
                    <Link to="/login" className={headerStyles.greenButton}>Sign In</Link>
                    <Link to="/signup" className={headerStyles.filledButton}>Sign Up</Link>
                </>
            )}
        </div>
    );
};

export default HeaderButtons;